"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _utils = require("../helpers/utils");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  promptButton: '[js-free-reads-prompt]'
};
/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */

var _default = function _default(config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    enableFeature: false
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  /**
   * DOM node selectors.
   */

  var nodeSelectors = {
    promptButton: _toConsumableArray(document.querySelectorAll(selectors.promptButton))
  };
  /**
   * Initialise component.
   */

  function init() {
    setTriggerEvents();
  }
  /**
   * Set trigger listeners.
   */


  function setTriggerEvents() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var promptBtn = _step.value;
        (0, _utils.on)('click', promptBtn, function (event) {
          event.preventDefault();
          var articleUrl = window.location.pathname;
          window.sessionStorage.removeItem('mb_free_reads');
          window.sessionStorage.setItem('mb_free_reads', articleUrl);
          window.location = promptBtn.href;
        });
      };

      for (var _iterator = nodeSelectors.promptButton[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;